/****************************************************
 * Module Name:  aboveMaxQuantityBarChart.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import Constants from "../../utility/constants";
import MixBucketProxy from "../../utility/proxy/manager/mixProxy/mixBucketProxy";
import { GiFoundryBucket } from "react-icons/gi";
import Utility from "../../utility/utility";
import MixBucketModal from "./mixBucketModal";

let useColor1 = Utility.GetRandomColorForBarChart();
let useColor2 = Utility.GetRandomColorForBarChart();

const AboveMaxQuantityBarChart = () => {
  const [chartData, setChartData] = useState([]);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [show, setShow] = useState(false);
  const [apiType, setApiType] = useState("");

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = () => {
    MixBucketProxy.GetAboveMaxQuantity((response) => {
      if (response) {
        setChartData(response);
      } else {
        setErrorSnackbar(true);
      }
    });
  };

  const handleModalOpen = () => {
    setShow(true);
    setApiType("above");
  };

  return (
    <div>
      <CommonSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />
      <MixBucketModal
        show={show}
        apiType={apiType}
        aboveData={chartData}
        handleClose={() => setShow(false)}
      />
      <Paper elevation={4}>
        <Card>
          <CardHeader
            avatar={<GiFoundryBucket size={25} color={useColor1} />}
            title={
              <Typography
                component="span"
                fontWeight={Constants.defaultFontWeight}
                fontSize={"1.25rem"}
              >
                Above Max Alert Quantity
              </Typography>
            }
            subheader="Quantity yet to be received by each Vendor"
          />
          <CardContent>
            <Box height={matches ? 300 : 500} width={matches ? 320 : "45vw"}>
              <ResponsiveContainer height={matches ? 300 : 500}>
                <BarChart
                  data={chartData}
                  onClick={(data) => handleModalOpen()}
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey={(value) =>
                      value.shape +
                      " | " +
                      value.size +
                      " | " +
                      value.color +
                      " | " +
                      value.clarity
                    }
                    hide={matches}
                  />
                  <YAxis hide={matches} />
                  <Tooltip />
                  <Legend formatter={(value, entry) => value + "(CTS)"} />
                  <Bar
                    dataKey="qty"
                    name="QUANTITY"
                    fill={useColor1}
                    unit={"cts"}
                    stroke="#000000"
                    strokeWidth={1}
                    label={{ position: "top" }}
                  />
                  <Bar
                    dataKey="maxalertqty"
                    name="MAX ALERT QUANTITY"
                    fill={useColor2}
                    unit={"cts"}
                    stroke="#000000"
                    strokeWidth={1}
                    label={{ position: "top" }}
                  />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </CardContent>
        </Card>
      </Paper>
    </div>
  );
};

export default AboveMaxQuantityBarChart;
